import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'main-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  version: string = localStorage.getItem('Version');
  messages: any = { version: '', copyright: '' };
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('vi');
    
    this.translate.get('common.version').subscribe(value => {      
      this.messages.version = value;
    });
    this.translate.get('common.copyright').subscribe(value => {      
      this.messages.copyright = value;
    });
  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/footer/footer.component.ts